import { config as legendConfig } from "../filterlist/config";

export const RiskModelLegend = () => {
  const factor = 30;
  const itemStyle = {
    paddingLeft: 10,
    fontSize: legendConfig.fontSize,
  };
  const circle = {
    height: 10,
    width: 10,
    border: "1px solid black",
    borderRadius: 10,
  };
  const triangleContainer = {
    width: `${500 / factor}px`,
    marginLeft:-4,
    textAlign: "center",
    transform: "rotate(90deg)"
  };

  const triangle = {
    fill: "transparent",
    stroke: "black",
    strokeWidth: 1,
  };

  const points = `${250 / factor},${130 / factor} ${100 / factor},${
    400 / factor
  } ${400 / factor},${400 / factor}`;

  const Triangle = () => {
    return (
      <div style={triangleContainer}>
        <svg height={500 / factor} width={500 / factor}>
          <polygon points={points} style={triangle} />
        </svg>
      </div>
    );
  };

  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td>
              <div style={circle}></div>
            </td>
            <td style={itemStyle}>Sigma</td>
          </tr>
          <tr>
            <td>
              <Triangle />
            </td>
            <td style={itemStyle}>Vector</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
